module.exports = __webpack_public_path__ + "assets_1789888786567/img/pic_6.13790e82.png";